export default "__VITE_ASSET__BdKTWjBU__"